import { useNavigate, useSearchParams } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import PropTypes from "prop-types";

const Auth0ProviderWithHistory = function ({ children }) {
  const { REACT_APP_AUTH0_DOMAIN, REACT_APP_AUTH0_CLIENT_ID } = import.meta.env;
  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  const [searchParams] = useSearchParams();
  const login_hint = searchParams.get("login_hint") ?? "";

  return (
    <Auth0Provider
      domain={REACT_APP_AUTH0_DOMAIN}
      clientId={REACT_APP_AUTH0_CLIENT_ID}
      onRedirectCallback={onRedirectCallback}
      scope="read:current_user"
      authorizationParams={{
        redirect_uri: window.location.origin,
        login_hint,
      }}
    >
      {children}
    </Auth0Provider>
  );
};

Auth0ProviderWithHistory.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Auth0ProviderWithHistory;
